import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { JiraAppSelectorIconWithGithub } from './jira-app-selector-with-github';
import { messages } from './messages';

const styles = cssMap({
	moreButtonStyles: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.small'),
		display: 'flex',
		marginLeft: token('space.050'),
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
	moreButtonStylesOld: {
		alignItems: 'center',
		backgroundColor: token('elevation.surface.sunken'),
		border: `${token('border.width')} solid ${token('color.border.inverse')}`,
		borderRadius: token('radius.small'),
		display: 'flex',
		paddingLeft: token('space.100'),
		paddingRight: token('space.075'),
	},
	iconsStylesOld: {
		display: 'flex',
		translate: token('space.025'),
	},
});

type Props = {
	appCount?: number;
};

export const AllAppsIconWithGithub = ({ appCount }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	if (fg('search_all_apps_icon_app_count')) {
		const label =
			appCount !== undefined && appCount > 0
				? formatMessage(messages.moreWithCount, { appCount })
				: formatMessage(messages.more);

		return (
			<Flex role="presentation" alignItems="center">
				<JiraAppSelectorIconWithGithub />

				<Box xcss={styles.moreButtonStyles}>
					<Text size="small" align="center" color="color.text.subtle">
						{label}
					</Text>
				</Box>
			</Flex>
		);
	}

	return (
		<Flex role="presentation" alignItems="center">
			<Box xcss={styles.iconsStylesOld}>
				<JiraAppSelectorIconWithGithub />
			</Box>

			<Box xcss={styles.moreButtonStylesOld}>
				<Text size="small" align="center" color="color.text.subtle">
					{formatMessage(messages.more)}
				</Text>
			</Box>
		</Flex>
	);
};
